import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { LinkContainer } from "react-router-bootstrap";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Container from "react-bootstrap/Container";
import Card from "react-bootstrap/Card";

import { AppLayout } from "../components/appLayout";
import { VideoAddEditForm } from "../components/forms/videoAddEditForm";
import useApiClient from "../hooks/useApiClient";
import { CategoryWithCountsViewModel, VideoViewModel } from "../apiClient";

export const VideoEdit = () => {
    const routeParams = useParams();
    const apiClient = useApiClient();
    const navigate = useNavigate();
    const [categories, setCategories] = useState<CategoryWithCountsViewModel[]>([]);
    const [video, setVideo] = useState<VideoViewModel | null>(null);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        if (!apiClient) return;

        const loadData = async () => {
            const categoriesPromise = apiClient.categoriesAll().then(categories => setCategories(categories));
            const videoPromise = apiClient.videosGET(routeParams.id!).then(video => setVideo(video));
            await Promise.all([categoriesPromise, videoPromise]);
            setLoading(false);
        };

        loadData();
    }, [apiClient, setCategories, setVideo, routeParams]);

    return (
        <AppLayout loading={loading}>
            <Container className="py-2">
                <Breadcrumb>
                    <LinkContainer to={`/`}>
                        <Breadcrumb.Item>Videos</Breadcrumb.Item>
                    </LinkContainer>
                    <Breadcrumb.Item active>Edit video</Breadcrumb.Item>
                </Breadcrumb>

                <div className="mb-3">
                    <h1 className="mb-1">Edit video: {video?.title}</h1>
                </div>

                <Card>
                    <Card.Body className="p-4">
                        <VideoAddEditForm
                            apiClient={apiClient!}
                            video={video!}
                            categories={categories}
                            onSave={() => navigate(`/`)}
                        />
                    </Card.Body>
                </Card>
            </Container>
        </AppLayout>
    );
};